import React from "react";
import "./Card.css";

export default function Card() {
  return (
    <>
      <div style={{ maxWidth: "1700px" }} class="container-fluid p-sm-5">
        <div class="p-0 p-sm-5">
          <div class="row textwala">
            <div class="col-sm-4 col-md-12 col-lg-5 mt-5">
              <img
                data-aos="flip-left"
                style={{   objectFit: "contain", }}
                src="/Images/iwd4.jpg"
                alt=""
                width="100% !important"
                height="450px"
              />
            </div>
            <div class="col- sm-7 col-md-12 col-lg-7 mt-5">
              <div>
                <h1 data-aos="zoom-in-up">
                  “Technology was the key to my freedom.”
                </h1>
                <p data-aos="zoom-in-up">
                  He Who is Not Courageous Enough to Take Risks Will Accomplish
                  Nothing in Life.
                </p>
              </div>
              <div class="div-2 mt-5">
                <div class="row">
                  <div class="col-sm-6">
                    <i class="fas fa-smile" data-aos="zoom-in-up">
                      {" "}
                      99
                    </i>
                    <p data-aos="zoom-in-up">
                      <strong>Happy clients</strong>" I appreciate your patience
                      on this. Please let me know if I can provide any other
                      additional support.”
                    </p>
                  </div>
                  <div class="col-sm-6">
                    <i class="fas fa-book" data-aos="zoom-in-up">
                      85
                    </i>
                    <p data-aos="zoom-in-up">
                      <strong>Projects </strong>“You may delay, but time will
                      not.” – Benjamin Franklin
                    </p>
                  </div>
                  <div class="col-sm-6">
                    <i class="fas fa-clock" data-aos="zoom-in-up">
                      12
                    </i>
                    <p data-aos="zoom-in-up">
                      <strong>Years of experience</strong>" No man ever steps in
                      the same river twice, for it's not the same river and he's
                      not the same man."
                    </p>
                  </div>
                  <div class="col-sm-6">
                    <i class="fas fa-medal" data-aos="zoom-in-up">
                      5
                    </i>
                    <p data-aos="zoom-in-up">
                      <strong>Awards </strong>"The strength of your achievement
                      is rooted in the depth of your passion. "
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr style={{ border: "1px solid white" }} className="my-0" />
    </>
  );
}
